module.exports = __webpack_public_path__ + "static/media/1-frantsen.c2feec8b.jpg";